<template>
  <div class="customer-info-panel">
    <div v-if="!customer" class="empty-state">
      <p>{{ $t('whatsapp.customerInfo.notArchived') }}</p>
      <el-button type="primary" size="small">{{ $t('whatsapp.customerInfo.archiveConversation') }}</el-button>
    </div>
    <div v-else class="customer-content">
      <div class="section info-section">
        <div class="info-row">
          <span class="label">{{ $t('whatsapp.customerInfo.customerCode') }}</span>
          <span class="value">{{ customer.customerCode || "—" }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t('whatsapp.customerInfo.creator') }}</span>
          <span class="value">{{ customer.createName || "—" }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t('whatsapp.customerInfo.manager') }}</span>
          <span class="value">{{ customer.managerName || "—" }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $t('whatsapp.customerInfo.createTime') }}</span>
          <span class="value">{{ customer.createTime || "—" }}</span>
        </div>
      </div>

      <div class="section">
        <div class="section-title">{{ $t('whatsapp.customerInfo.companyInfo') }}</div>
        <div
          v-for="item in companyInfoList"
          :key="item.name"
          class="info-row"
        >
          <span class="label">{{ item.name }}</span>
          <span class="value">{{ formatValue(item.value) }}</span>
        </div>
      </div>

      <div class="section">
        <div class="section-title">{{ $t('whatsapp.customerInfo.marketingInfo') }}</div>
        <div
          v-for="item in marketingInfoList"
          :key="item.name"
          class="info-row"
        >
          <span class="label">{{ item.name }}</span>
          <span class="value">{{ formatValue(item.value) }}</span>
        </div>
      </div>

      <div class="section">
        <div class="section-title">{{ $t('whatsapp.customerInfo.contacts') }}</div>
        <div
          v-for="(item, idx) in contactList"
          :key="idx"
          class="info-row contact-row"
        >
          <el-icon class="contact-icon"><User /></el-icon>
          <div class="contact-info">
            <span class="contact-name">{{ item.name || "—" }}</span>
            <span class="contact-email">{{ item.email || "—" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { User } from "@element-plus/icons-vue";

export default {
  name: "CustomerInfoPanel",
  components: { User },
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  computed: {
    companyInfoList() {
      const c = this.customer;
      if (!c) return [];
      return [
        { name: this.$t('whatsapp.customerInfo.zone'), value: c.zoneAddress },
        { name: this.$t('whatsapp.customerInfo.source'), value: c.customerOriginList },
        { name: this.$t('whatsapp.customerInfo.foundedTime'), value: c.setUpTime },
        { name: this.$t('whatsapp.customerInfo.economicNature'), value: c.economicNature },
        { name: this.$t('whatsapp.customerInfo.companyEmail'), value: c.email },
        { name: this.$t('whatsapp.customerInfo.companyAddress'), value: c.companyAddress },
        { name: this.$t('whatsapp.customerInfo.phoneNumber'), value: c.phone },
        { name: this.$t('whatsapp.customerInfo.faxNumber'), value: c.companyFax },
        { name: this.$t('whatsapp.customerInfo.website'), value: c.companyWebsite },
        { name: this.$t('whatsapp.customerInfo.otherRemarks'), value: c.companyRemark },
      ];
    },
    marketingInfoList() {
      const c = this.customer;
      if (!c) return [];
      return [
        { name: this.$t('whatsapp.customerInfo.customerType'), value: c.customerType },
        { name: this.$t('whatsapp.customerInfo.customerLevel'), value: c.customerLevel },
        { name: this.$t('whatsapp.customerInfo.products'), value: c.productList },
        { name: this.$t('whatsapp.customerInfo.marketingRemarks'), value: c.marketingRemark },
      ];
    },
    contactList() {
      const c = this.customer;
      if (!c || !c.contactList) return [];
      return c.contactList;
    },
  },
  methods: {
    formatValue(val) {
      if (val == null || val === "") return "—";
      if (Array.isArray(val)) {
        const names = val.map((v) => (typeof v === "object" ? v.name : v));
        return names.filter(Boolean).join("、") || "—";
      }
      return String(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-info-panel {
  height: 100%;
  overflow-y: auto;
  min-height: 0;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;

  p {
    margin: 0 0 16px;
    font-size: 13px;
    color: #999;
  }
}

.customer-content {
  padding-bottom: 20px;
}

.section {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.section-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.info-row {
  display: flex;
  margin-bottom: 10px;
  font-size: 13px;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    flex: 0 0 80px;
    color: #999;
  }

  .value {
    flex: 1;
    color: #333;
    word-break: break-all;
  }
}

.contact-row {
  align-items: flex-start;
  gap: 8px;

  .contact-icon {
    flex: 0 0 auto;
    margin-top: 2px;
    color: #999;
  }

  .contact-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .contact-name {
      font-size: 13px;
      color: #333;
    }

    .contact-email {
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
